// extracted by mini-css-extract-plugin
module.exports = {"Links":"Links_Links__TYs7g","LinksList":"Links_LinksList___qVCS","LinksSocial":"Links_LinksSocial__EFF_X"};